module.exports = __webpack_public_path__ + "static/img/major_pictgrid24_920x849.10cdbaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid24_920x849.jpg
// module id = n4Ll
// module chunks = 0